import { TeeSheetHoleCountSelectorControl } from "@/features/TeeSheet/components/TeeSheetBasedFilters";
import { HoleCount } from "@whoosh/design-system/src/components/icons_v2/courseLayout/icons/HoleCountIcon";

type Props = {
  holeCount: HoleCount | undefined;
  onChange: (holeCount: HoleCount | null) => void;
};

export const DepartmentAvailabilityHoleCountSelect = ({
  holeCount,
  onChange,
}: Props) => {
  return (
    <TeeSheetHoleCountSelectorControl
      onChange={onChange}
      value={holeCount ?? null}
    />
  );
};
